import cx from 'clsx'
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

import cn from '../styles.module.scss'

export interface IHeadingProps
  extends DetailedHTMLProps<
    HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {
  level?: 1 | 2 | 3
  color?: 'black' | 'white' | 'gradient'
  weight?: 'normal' | 'medium' | 'bold'
  opacity?: number
}

const Heading = ({
  level = 1,
  color = 'black',
  weight = 'normal',
  opacity = 1,
  children,
  className,
  style,
  ...rest
}: IHeadingProps) => {
  const classes = cx(
    {
      [cn.h1]: level === 1,
      [cn.h2]: level === 2,
      [cn.h3]: level === 3,
    },
    cn[color],
    cn[weight],
    className,
  )

  switch (level) {
    case 1:
      return (
        <h1 {...rest} className={classes} style={{ opacity, ...style }}>
          {children}
        </h1>
      )

    case 2:
      return (
        <h2 {...rest} className={classes} style={{ opacity, ...style }}>
          {children}
        </h2>
      )

    case 3:
      return (
        <h3 {...rest} className={classes} style={{ opacity, ...style }}>
          {children}
        </h3>
      )

    default:
      return null
  }
}

export default Heading
